var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination',{staticClass:"my-0",attrs:{"value":_vm.currentPage,"per-page":_vm.pageSize,"total-rows":_vm.total,"align":"fill"},on:{"input":function (newCurrentPage) { return _vm.setCurrentPage(newCurrentPage); }}})}
var staticRenderFns = []

export { render, staticRenderFns }